import { useSuspenseQuery } from "@apollo/client/react";

import { GetUsersDocument, type GetUsersQuery, type GetUsersQueryVariables } from "~/features/admin/users/gqls";

/**
 * Loads the full user list. GetUsers is tenant-scoped server-side via the Hasura
 * session (no `tenantId` variable), so the whole list is fetched at once and
 * filtered / paginated client-side — V1 parity.
 */
export function useUsersList() {
  return useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, {
    fetchPolicy: "cache-and-network",
  });
}
